import { defineMessages } from 'react-intl';

export const da = defineMessages({
  description: {
    defaultMessage: `Top Danish Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Danish with Movies`,
  },
});

export const de = defineMessages({
  description: {
    defaultMessage: `Top German Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn German with Movies`,
  },
});

export const el = defineMessages({
  description: {
    defaultMessage: `Top Greek Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Greek with Movies`,
  },
});

export const en = defineMessages({
  description: {
    defaultMessage: `Top English Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn English with Movies`,
  },
});

export const en_us = defineMessages({
  description: {
    defaultMessage: `Top English Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn English with Movies`,
  },
});

export const es = defineMessages({
  description: {
    defaultMessage: `Watch and Learn with the Best Spanish Movies`,
  },
  title: {
    defaultMessage: `Top Spanish Cinema`,
  },
});

export const es_mx = defineMessages({
  description: {
    defaultMessage: `Watch and Learn with the Best Mexican Movies`,
  },
  title: {
    defaultMessage: `Top Mexican Cinema`,
  },
});

export const fa = defineMessages({
  description: {
    defaultMessage: `Top Persian Movies for Language Enthusiasts`,
  },
  title: {
    defaultMessage: `Dive into Persian Culture`,
  },
});

export const fr = defineMessages({
  description: {
    defaultMessage: `Top French Movies for Language Enthusiasts`,
  },
  title: {
    defaultMessage: `Dive into French Culture`,
  },
});

export const he = defineMessages({
  description: {
    defaultMessage: `Top Hebrew Movies for Language Enthusiasts`,
  },
  title: {
    defaultMessage: `Dive into Hebrew Culture`,
  },
});

export const hi = defineMessages({
  description: {
    defaultMessage: `Top Hindi Movies for Language Enthusiasts`,
  },
  title: {
    defaultMessage: `Dive into Hindi Culture`,
  },
});

export const id = defineMessages({
  description: {
    defaultMessage: `Top Indonesian Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Indonesian with Movies`,
  },
});

export const is = defineMessages({
  description: {
    defaultMessage: `Top Icelandic Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Icelandic with Movies`,
  },
});

export const it = defineMessages({
  description: {
    defaultMessage: `with Blockbuster Movies & Shows from Netflix to Prime`,
  },
  title: {
    defaultMessage: `Get Your Italian on Point`,
  },
});

export const jp_full = defineMessages({
  description: {
    defaultMessage: `Essential Japanese Films for Language Enthusiasts`,
  },
  title: {
    defaultMessage: `Dive into Japanese with Movies`,
  },
});

export const jp_romaji = defineMessages({
  description: {
    defaultMessage: `Top Japanese (Romaji) Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Japanese (Romaji) with Movies`,
  },
});

export const ko = defineMessages({
  description: {
    defaultMessage: `Top Korean Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Korean with Movies`,
  },
});

export const mn = defineMessages({
  description: {
    defaultMessage: `Top Mongolian Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Mongolian with Movies`,
  },
});

export const nl = defineMessages({
  description: {
    defaultMessage: `Top Dutch Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Dutch with Movies`,
  },
});

export const no = defineMessages({
  description: {
    defaultMessage: `Top Norwegian Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Norwegian with Movies`,
  },
});

export const pl = defineMessages({
  description: {
    defaultMessage: `Top Polish Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Polish with Movies`,
  },
});

export const pt = defineMessages({
  description: {
    defaultMessage: `Top Portuguese (EU) Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Portuguese (EU) with Movies`,
  },
});

export const pt_br = defineMessages({
  description: {
    defaultMessage: `Top Portuguese (BR) Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Portuguese (BR) with Movies`,
  },
});

export const ru = defineMessages({
  description: {
    defaultMessage: `Top Russian Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Russian with Movies`,
  },
});

export const sl = defineMessages({
  description: {
    defaultMessage: `Top Slovenian Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Slovenian with Movies`,
  },
});

export const sv = defineMessages({
  description: {
    defaultMessage: `Top Swedish Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Swedish with Movies`,
  },
});

export const sw = defineMessages({
  description: {
    defaultMessage: `Top Swahili Movies for Language Enthusiasts`,
  },
  title: {
    defaultMessage: `Dive into Swahili Culture`,
  },
});

export const th = defineMessages({
  description: {
    defaultMessage: `Top Thai Movies for Language Enthusiasts`,
  },
  title: {
    defaultMessage: `Dive into Thai Culture`,
  },
});

export const tr = defineMessages({
  description: {
    defaultMessage: `Top Turkish Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Turkish with Movies`,
  },
});

export const uk = defineMessages({
  description: {
    defaultMessage: `Top Ukrainian Movies for Language Enthusiasts`,
  },
  title: {
    defaultMessage: `Dive into Ukrainian Culture`,
  },
});

export const yo = defineMessages({
  description: {
    defaultMessage: `Top Yoruba Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Yoruba with Movies`,
  },
});

export const zh_cn = defineMessages({
  description: {
    defaultMessage: `Top Chinese Films to watch for language learners`,
  },
  title: {
    defaultMessage: `Learn Chinese with Movies`,
  },
});
